import { MenuItem } from './menu-item';

export interface MenuGroup {
  name: string;
  route: string;
  openInNewTab: boolean;
  items: MenuItem[];

  // UI only
  open: any;
}
